<template src="./PendingSchedule.html"></template>
<script>
import moment from "moment";
import mixins from "../../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      doctor: null,
      popupRefuse: false,
      specialty: null,
      pendency: [],
      idPendency: null,
      idScheduleDoctor: null,
      doctors: [],
      popupAgendamento: false,
      selected: [],
      clinics: [],
      interval: [],
      newDate: false,
      initialDate: "",
      disabledDate: true,
      dateUSFormat: "",
      dateUSFormat1: "",
      dateUSFormat2: "",
      hourSelected: undefined,
      hourSelected1: undefined,
      hourSelected2: undefined,
      clinicSelected: undefined,
      currentPage: 1,
      totalPages: 0,
      totalPendency: 0,
      windowWidth: 0,
      scheduling: {
        price: ""
      },
      patient: {
        name: "",
        phone: "",
        age: "",
        email: ""
      },
      numHorarios: 0,
      atendimentoRadio0: undefined,
      atendimentoRadio1: undefined,
      atendimentoRadio2: undefined,
      messageUndefined: "Não definido",
      messageVideo: "Por vídeo",
      messagePresencial: "Presencial"
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  watch: {
    currentPage() {
    this.getScheduled();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  },
  methods: {
    init() {
      this.getScheduled();
      this.windowWidth = window.innerWidth;
      window.addEventListener("resize", this.handleResize);
    },
    confirmed() {
      const vm = this;
      let idPendancyConsult = vm.pendency[vm.idPendency].id;
      if (
        vm.dateUSFormat === "" ||
        vm.dateUSFormat === null ||
        vm.dateFormatted === undefined ||
        vm.hourSelected === "" ||
        vm.hourSelected === null ||
        vm.hourSelected === undefined ||
        vm.clinicSelected === "" ||
        vm.doctor === null
      ) {
        vm.$vs.notify({
          title: "Por favor",
          text: "Preencha todos os campos!",
          time: 2000,
          position: "top-right",
          color: "warning",
          icon: "error"
        });
        return;
      } else {
        let scheduleDoctorId = vm.pendency[vm.idPendency].scheduleDoctorId;
        let formatDateToBR = moment(String(vm.dateUSFormat)).format("DD/MM/YYYY");
        let formatDateToBR1 = moment(String(vm.dateUSFormat1)).format("DD/MM/YYYY");
        let formatDateToBR2 = moment(String(vm.dateUSFormat2)).format("DD/MM/YYYY");

        let appointment = {
          dateHour: formatDateToBR + " " + vm.hourSelected,
          dateHour1: null,
          dateHour2: null,
          scheduleDoctorId: scheduleDoctorId,
          webClinicId: vm.clinicSelected,
          doctor: vm.doctor,
          attendanceType:  vm.scheduling.attendanceType,
          kindAttendance0: vm.scheduling.attendanceType === 2 ? "tele" : "presencial",
          kindAttendance1: vm.scheduling.attendanceType === 2 ? "tele" : "presencial",
          kindAttendance2: vm.scheduling.attendanceType === 2 ? "tele" : "presencial",

        };
      if (vm.hourSelected1 != undefined && vm.numHorarios > 0) {
        appointment.dateHour1 = formatDateToBR1 + " " + vm.hourSelected1;
      }
      if (vm.hourSelected2 != undefined && vm.numHorarios > 1) {
        appointment.dateHour2 = formatDateToBR2 + " " + vm.hourSelected2;
      }
        vm.axios
          .put(
            vm.$store.state.filooServer +
              "webclinics/schedules/" +
              idPendancyConsult +
              "/accept",
            appointment,
            {
              headers: { Authorization: vm.$session.get("bearer") }
            }
          )
          .catch(function(response) {
            vm.popupAgendamento = false;
            if(response.status === 200 || response.status === 204){
            vm.$swal(
              "Solicitação enviada",
              "Aguarde até que o paciente aceite o agendamento.",
              "success"
            );
          }else{
            vm.$swal("Erro ao aceitar", "Contacte o administrador do sistema", "error");
          }
          vm.getScheduled();
          });
      }
    },
    getScheduled() {
  const vm = this;
  const page = vm.currentPage - 1;

  vm.axios
    .get(`${vm.$store.state.filooServer}webclinics/schedules?page=${page}&size=10&sort=id,asc`, {
      headers: { Authorization: vm.$session.get("bearer") }
    })
    .then((response) => {
      if (response.status === 200) {
        vm.pendency = response.data.content;
        vm.totalPages = response.data.totalPages;
        vm.totalPendency = response.data.totalElements;

        for (let p in vm.pendency) {
          vm.pendency[p].price = vm.maskMoney(vm.pendency[p].price);
        }
      }
    });
},
    getClinics() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "doctor/clinic-doctors", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          vm.clinics = response.data.content;
        });
    },
    clickBtnConfirmMedicalConsultation(tr, indextr) {
      const vm = this;

      vm.hourSelected = null;
      vm.hourSelected1 = null;
      vm.hourSelected2 = null;
      vm.initialDate = vm.dateFormatted(moment(String(vm.dateFormatted(tr[indextr].date))).format("DD/MM/YYYY"));
      vm.dateUSFormat = vm.dateFormatted(moment(String(vm.dateFormatted(tr[indextr].date))).format("DD/MM/YYYY"));

      vm.dateUSFormat1 = null;
      vm.dateUSFormat2 = null;
      vm.doctor = null;
      vm.idPendency = indextr;

      vm.doctors[0] = vm.pendency[indextr].doctors[0];
      vm.interval = tr[indextr].interval;
      vm.popupAgendamento = true;
      vm.scheduling.price = tr[indextr].price;
      vm.patient.name = tr[indextr].patient.name;
      vm.patient.age = tr[indextr].patient.age;
      vm.patient.phone = tr[indextr].patient.phone;
      vm.patient.email = tr[indextr].patient.email;
      vm.specialty = tr[indextr].specialty.name;
      vm.scheduling.attendanceType = tr[indextr].attendanceType;
    },
    refuseMedicalConsultation(tr, indextr) {
      const vm = this;
      vm.idScheduleDoctor = tr[indextr].scheduleDoctorId;
      vm.popupRefuse = true;
    },
    clickBtnRefuseConfirm() {
      const vm = this;
      let idPendancyConsult = vm.idScheduleDoctor;
      let appointment = {
        scheduleDoctorId: vm.idScheduleDoctor
      };
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/schedules/" +
            idPendancyConsult +
            "/refuse-doctor",
          appointment,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          vm.popupRefuse = false;
          if (response.status === 200) {
            vm.getScheduled();
            vm.$swal("Sucesso!", "Consulta cancelada", "success");
          } else {
            vm.$swal("Erro ao cancelar", "error");
          }
        })
        .catch(function() {
          vm.$swal("Erro ao aceitar", "error");
        });
    },
    dateFormatted(date) {
      let day = date.split("/")[0];
      let month = date.split("/")[1];
      let year = date.split("/")[2];

      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    clickNewDate() {
      const vm = this;
      vm.newDate = true;
      vm.disabledDate = false;
    },
    clickGoBackDate() {
      const vm = this;
      vm.newDate = false;
      vm.dateUSFormat = vm.initialDate;
      vm.disabledDate = true;
    },
    clickNewHorario() {
      const vm = this;
      if (vm.numHorarios < 3) {
        vm.numHorarios = vm.numHorarios + 1;
      }
    },
    clickGoBackHorario() {
      const vm = this;
      if (vm.numHorarios > 0) {
        vm.numHorarios = vm.numHorarios - 1;
      }
    }
  }
};
</script>

<style lang="scss" src="./PendingSchedule.scss">
</style>
